<template>
  <div>
    <v-row>
      <v-col cols="12">
        <p class="text-2xl">
          Templates
        </p>
        <v-card
          flat
        >
          <v-card-text class="pa-3">
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="3"
              >
                <v-text-field
                  v-model="filterName"
                  :append-icon="icons.mdiMagnify"
                  label="Nome"
                  hide-details
                  outlined
                  dense
                  @click:append="fechSmsTemplates"
                  @keypress.enter="fechSmsTemplates"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn
              color="primary"
              class="pl-4"
              @click="fechSmsTemplates"
            >
              Pesquisar
              <v-icon
                right
                dark
              >
                {{ icons.mdiFileEdit }}
              </v-icon>
            </v-btn>
            <v-btn
              color="primary"
              class="pl-4"
              outlined
              @click="openFormToCreate"
            >
              Novo Template SMS
              <v-icon
                right
                dark
              >
                {{ icons.mdiTablePlus }}
              </v-icon>
            </v-btn>
            <v-btn
              v-if="isAdmin"
              color="primary"
              class="pl-4"
              outlined
              @click="openFormToCreateRcs"
            >
              Novo Template RCS
              <v-icon
                right
                dark
              >
                {{ icons.mdiTablePlus }}
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card
          flat
          class="mt-5"
        >
          <v-data-table
            :headers="headers"
            :items="rows"
            item-key="id"
            class="table-rounded"
            disable-sort
            dense
          >
            <template #[`item.action`]="{item}">
              <v-btn
                color="#B71C1C"
                dark
                text
                title="Editar"
                x-small
                @click="openFormToEdit(item.id)"
              >
                <v-icon>{{ icons.mdiFileEdit }}</v-icon>
              </v-btn>
            </template>
            <template #[`item.status`]="{item}">
              <v-chip
                class="my-2"
                :color="resolveStatus(item.status).color"
                small
                label
              >
                <span class="white--text font-weight-semibold">
                  {{ resolveStatus(item.status).value }}
                </span>
              </v-chip>
            </template>
            <template #[`item.variables`]="{item}">
              <v-chip
                v-for="(variable, index) in ['NUMERO', ...item.variables]"
                :key="index"
                class="ma-1"
                small
              >
                <span class="white--text font-weight-semibold primary--text">
                  {{ variable }}
                </span>
              </v-chip>
            </template>
            <template #[`item.serviceIds`]="{item}">
              <v-chip
                v-for="(service, index) in item.serviceIds"
                :key="index"
                class="ma-1"
                small
              >
                <span class="white--text font-weight-semibold primary--text">
                  {{ resolveServiceName(service) }}
                </span>
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <validation-observer
      ref="formSmsTemplate"
      autocomplete="off"
      tag="form"
      @keyup.enter="fetchAction"
    >
      <dialog-form
        :status="formDialogStatus"
        :is-update="formIsUpdate"
        :title="'SMS Template'"
        :width="1200"
        @action="fetchAction"
        @remove="removeDialogStatus = true"
        @close="formDialogStatus = !formDialogStatus"
      >
        <v-row>
          <v-col
            cols="6"
            md="6"
            sm="12"
          >
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Nome"
                  rules="required|max:100"
                  vid="form.name"
                >
                  <v-text-field
                    v-model="form.name"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    label="Nome"
                    outlined
                    dense
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Mensagem"
                  rules="required"
                  vid="form.message"
                >
                  <v-textarea
                    v-model="form.message"
                    :counter-value="(value) => getMessageLenth(value)"
                    :error-messages="errors"
                    counter="160"
                    hint="Para utilizar uma variável, insira-a entre chaves {}, como no exemplo: {NOME}."
                    persistent-hint
                    label="Mensagem (A variável {NUMERO} é reservada para o número do destinatário)"
                    outlined
                    dense
                  >
                  </v-textarea>
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-select
                  v-model="form.variables"
                  :items="form.variables"
                  disabled
                  chips
                  label="Variáveis utilizadas"
                  multiple
                  outlined
                  dense
                >
                  <template v-slot:selection="{ item }">
                    <v-chip
                      color="info"
                      label
                      small
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>

              <v-col
                cols="12"
                md="12"
              >
                <v-checkbox
                  hide-details
                  class="me-3 mt-1"
                  v-model="form.useVoiceOtp"
                >
                  <template v-slot:label>
                    <span class="dark:white--text">Usar no OTP Voz</span>
                  </template>
                </v-checkbox>
              </v-col>
       
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="d-sm-flex justify-center position-relative"
          >
            <div class="phone">
              <div class="speaker"></div>
              <div style="width: 425px; height: 771px">
                <div class="center">
                  <div class="chat">
                    <div
                      id="chat"
                      class="messages"
                    >
                      <div
                        v-if="messageChat"
                        class="message parker"
                      >
                        <!-- eslint-disable vue/no-v-html -->
                        <span v-html="messageChat" />
                        <!--eslint-enable-->
                      </div>
                    </div>
                    <div class="input">
                      <input
                        placeholder="Enviar mensagem..."
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </dialog-form>
    </validation-observer>

    <!-- Nova popup para RCS Template -->
    <validation-observer
      ref="formRcsTemplate"
      autocomplete="off"
      tag="form"
      @keyup.enter="fetchActionRcs"
    >
      <dialog-form
        :status="formRcsDialogStatus"
        :is-update="formRcsIsUpdate"
        :title="'RCS Template'"
        :width="1200"
        @action="fetchActionRcs"
        @close="formRcsDialogStatus = !formRcsDialogStatus"
      >
        <v-row>
          <v-col
            cols="6"
            sm="12"
            md="6"
          >
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Nome"
                  rules="required|max:100"
                  vid="formRcs.name"
                >
                  <v-text-field
                    v-model="formRcs.name"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    label="Nome"
                    outlined
                    dense
                  />
                </validation-provider>
              </v-col>
              
              <!-- Fornecedor RCS -->
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Fornecedor"
                  rules="required"
                  vid="formRcs.supplier"
                >
                  <v-select
                    v-model="formRcs.supplier"
                    :items="suppliers"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    outlined
                    dense
                    item-text="text"
                    item-value="value"
                    label="Fornecedor"
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Tipo"
                  rules="required"
                  vid="formRcs.typeRcs"
                >
                  <v-select
                    v-model="formRcs.typeRcs"
                    :items="availableRcsTypes"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    outlined
                    item-text="text"
                    dense
                    item-value="value"
                    label="Tipo"
                    :disabled="!formRcs.supplier"
                  />
                </validation-provider>
              </v-col>

              <!-- Título - para RICHCARD e SIMPLE_TEXT -->
              <v-col
                v-if="formRcs.typeRcs !== 'CAROUSEL'"
                cols="12"
                md="6"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Título"
                  rules="max:100"
                  vid="formRcs.title"
                >
                  <v-text-field
                    v-model="formRcs.title"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    label="Título"
                    outlined
                    dense
                  />
                </validation-provider>
              </v-col>
              <!-- Tamanho da Imagem - apenas para RICHCARD (não para SIMPLE_TEXT) -->
              <v-col
                v-if="formRcs.typeRcs === 'RICHCARD'"
                cols="12"
                md="12"
                sm="12"
              >
                <v-select
                  v-model="formRcs.imageSize"
                  :items="imageSizeOptions"
                  item-text="text"
                  item-value="value"
                  label="Tamanho da Imagem"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <!-- Mensagem principal - apenas para RICHCARD -->
              <v-col
                v-if="formRcs.typeRcs !== 'CAROUSEL'"
                cols="12"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Mensagem"
                  rules="required"
                  vid="formRcs.description"
                >
                  <v-textarea
                    v-model="formRcs.description"
                    :counter-value="(value) => getMessageLenth(value)"
                    :error-messages="errors"
                    counter="999"
                    hint="Para utilizar uma variável, insira-a entre chaves {}, como no exemplo: {NOME}."
                    persistent-hint
                    label="Mensagem (A variável {NUMERO} é reservada para o número do destinatário)"
                    outlined
                    dense
                  >
                  </v-textarea>
                </validation-provider>
              </v-col>
              <!-- Variáveis - apenas para RICHCARD -->
              <v-col
                v-if="formRcs.typeRcs !== 'CAROUSEL'"
                cols="12"
                sm="12"
              >
                <v-select
                  v-model="formRcs.variables"
                  :items="formRcs.variables"
                  disabled
                  chips
                  label="Variáveis utilizadas"
                  multiple
                  outlined
                  dense
                >
                  <template v-slot:selection="{ item }">
                    <v-chip
                      color="info"
                      label
                      small
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <!-- Aviso para CAROUSEL -->
              <v-col
                v-if="formRcs.typeRcs === 'CAROUSEL'"
                cols="12"
                sm="12"
              >
                <v-alert
                  type="info"
                  dense
                  outlined
                  class="mb-0"
                >
                  No modo Carrossel, cada imagem terá sua própria mensagem. Adicione as imagens abaixo.
                </v-alert>
              </v-col>
              <!-- Título do Botão e URL de Ação - apenas para RICHCARD -->
              <template v-if="formRcs.typeRcs === 'RICHCARD'">
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="Título do Botão"
                    :rules="formRcs.actionUrl ? 'required|max:50' : ''"
                    vid="formRcs.buttonTitle"
                  >
                    <v-text-field
                      v-model="formRcs.buttonTitle"
                      :error-messages="errors"
                      :hide-details="errors.length === 0"
                      label="Título do Botão"
                      hint="Ex: Clique aqui, Acesse, Saiba mais"
                      persistent-hint
                      outlined
                      dense
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="URL de Ação"
                    rules="required|url"
                    vid="formRcs.actionUrl"
                  >
                    <v-text-field
                      v-model="formRcs.actionUrl"
                      :error-messages="errors"
                      :hide-details="errors.length === 0"
                      label="URL de Ação"
                      outlined
                      dense
                    />
                  </validation-provider>
                </v-col>
              </template>

              <!-- Campos de Fallback - aparecem independente do tipo -->
              <v-col
                cols="12"
                md="12"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Título do Fallback"
                  rules="max:100"
                  vid="formRcs.fallbackTitle"
                >
                  <v-text-field
                    v-model="formRcs.fallbackTitle"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    label="Título do Fallback"
                    outlined
                    dense
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="12"
                sm="12"
              >
              <validation-provider
                  v-slot="{ errors }"
                  name="Mensagem do Fallback"
                  rules="required"
                  vid="formRcs.fallbackMessage"
                >
                  <v-textarea
                    v-model="formRcs.fallbackMessage"
                    :counter-value="(value) => getMessageLenth(value)"
                    :error-messages="errors"
                    counter="160"
                    hint="Para utilizar uma variável, insira-a entre chaves {}, como no exemplo: {NOME}."
                    persistent-hint
                    label="Mensagem do Fallback"
                    outlined
                    dense
                  >
                  </v-textarea>
                </validation-provider>
              </v-col>

              <v-col
                v-if="formRcs.typeRcs !== 'SIMPLE_TEXT'"
                cols="12"
                sm="12"
              >
                <!-- Upload para RICHCARD -->
                <div
                  v-if="formRcs.typeRcs === 'RICHCARD'"
                  class="upload-area-wrapper"
                >
                  <v-tooltip
                    top
                    max-width="300"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        class="upload-help-icon"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-icon x-small color="grey darken-1">
                          {{ icons.mdiHelpCircle }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span style="white-space: pre-line;">{{ imageDimensionsTooltip }}</span>
                  </v-tooltip>
                  <div
                    class="upload-area"
                    :class="{ 'dragover': isDragging }"
                    @drop.prevent="onFileDrop"
                    @dragover.prevent
                    @dragenter.prevent="onDragEnter"
                    @dragleave.prevent="onDragLeave"
                    @click="openFileSelector"
                  >
                    <input
                      :key="`file-input-${formRcs.typeRcs}`"
                      ref="fileInput"
                      type="file"
                      accept="image/*,video/*"
                      :multiple="false"
                      style="display: none"
                      @change="onFileSelect"
                    />
                  <div v-if="formRcs.imageFiles.length === 0" class="upload-content">
                    <v-icon size="48" color="grey lighten-1">mdi-cloud-upload</v-icon>
                    <p class="upload-text">Arraste e solte uma imagem ou vídeo aqui</p>
                    <p class="upload-subtext">ou clique para selecionar</p>
                    <p class="upload-info">Imagens até 2 MB e vídeos até 20 MB</p>
                    <p class="upload-info" style="color: #ff9800; margin-top: 8px;">
                      Apenas 1 mídia permitida
                    </p>
                  </div>
                  <div v-if="formRcs.imageFiles.length > 0" class="files-selected">
                    <div
                      v-for="(file, index) in formRcs.imageFiles"
                      :key="index"
                      class="file-item"
                    >
                      <v-icon size="24" color="success">mdi-check-circle</v-icon>
                      <p class="file-name">{{ file.name }}</p>
                      <v-btn
                        icon
                        x-medium
                        color="error"
                        @click.stop="removeImage(index)"
                        title="Remover mídia"
                      >
                        <v-icon x-medium>{{ icons.mdiClose }}</v-icon>
                      </v-btn>
                    </div>
                    <p v-if="formRcs.imageFiles.length > 1" class="upload-info" style="color: #f44336; margin-top: 8px;">
                      Apenas 1 mídia é permitida para Rich Card. Remova os arquivos extras.
                    </p>
                  </div>
                  </div>
                </div>

                <!-- Upload para CAROUSEL com mensagem por imagem -->
                <div v-if="formRcs.typeRcs === 'CAROUSEL'" class="upload-area-wrapper">
                  <v-tooltip
                    top
                    max-width="300"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        class="upload-help-icon"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-icon x-small color="grey darken-1">
                          {{ icons.mdiHelpCircle }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span style="white-space: pre-line;">{{ imageDimensionsTooltip }}</span>
                  </v-tooltip>
                  <div>
                  <!-- Área de upload para adicionar novas imagens -->
                  <div
                    class="upload-area upload-area-small"
                    :class="{ 'dragover': isDragging }"
                    @drop.prevent="onFileDrop"
                    @dragover.prevent
                    @dragenter.prevent="onDragEnter"
                    @dragleave.prevent="onDragLeave"
                    @click="openFileSelector"
                  >
                    <input
                      :key="`file-input-carousel-${formRcs.carouselItems.length}`"
                      ref="fileInput"
                      type="file"
                      accept="image/*,video/*"
                      multiple
                      style="display: none"
                      @change="onFileSelect"
                    />
                    <div class="upload-content">
                      <v-icon size="32" color="grey lighten-1">mdi-plus-circle</v-icon>
                      <p class="upload-text">Adicionar mídias ao Carrossel</p>
                      <p class="upload-subtext">Clique ou arraste imagens e vídeos aqui</p>
                    </div>
                  </div>

                  <!-- Lista de imagens do carousel com mensagem individual -->
                  <div v-if="formRcs.carouselItems.length > 0" class="carousel-items-list mt-4">
                    <div
                      v-for="(item, index) in formRcs.carouselItems"
                      :key="index"
                      class="carousel-item-card"
                    >
                      <div class="carousel-item-header">
                        <span class="carousel-item-number">Carousel {{ index + 1 }}</span>
                        <v-btn
                          icon
                          small
                          color="error"
                          @click="removeCarouselItem(index)"
                          title="Remover slide"
                        >
                          <v-icon small>{{ icons.mdiClose }}</v-icon>
                        </v-btn>
                      </div>
                      <div class="carousel-item-content">
                        <div class="carousel-item-image">
                          <video
                            v-if="isVideoFile(item.file)"
                            :src="getImageUrl(item.file)"
                            class="carousel-thumb"
                            muted
                          />
                          <img
                            v-else
                            :src="getImageUrl(item.file)"
                            :alt="`Carousel ${index + 1}`"
                            class="carousel-thumb"
                          />
                        </div>
                        <div class="carousel-item-form">
                          <p class="file-name-small mb-2">{{ item.file.name }}</p>
                          <v-row dense>
                            <v-col cols="6">
                              <v-text-field
                                v-model="item.title"
                                label="Título"
                                outlined
                                dense
                                hide-details
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-select
                                v-model="item.imageSize"
                                :items="imageSizeOptions"
                                item-text="text"
                                item-value="value"
                                label="Tamanho"
                                outlined
                                dense
                                hide-details
                              />
                            </v-col>
                            <v-col cols="12" class="mt-2">
                              <v-textarea
                                v-model="item.message"
                                :counter-value="(value) => getMessageLenth(value || '')"
                                counter="500"
                                label="Mensagem"
                                outlined
                                dense
                                rows="2"
                                hide-details="auto"
                                @input="updateCarouselMessage(index, $event)"
                              />
                            </v-col>
                            <v-col cols="12" md="6" class="mt-2">
                              <v-text-field
                                v-model="item.buttonTitle"
                                label="Título do Botão"
                                outlined
                                dense
                                hide-details
                                placeholder="Ex: Clique aqui, Acesse"
                                hint="Texto que aparecerá no botão"
                                persistent-hint
                              />
                            </v-col>
                            <v-col cols="12" md="6" class="mt-2">
                              <v-text-field
                                v-model="item.actionUrl"
                                label="URL de Ação"
                                outlined
                                dense
                                hide-details
                                placeholder="https://exemplo.com/acao"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                  </div>

                  <p v-if="formRcs.carouselItems.length === 0" class="upload-info mt-2" style="text-align: center; color: #ff9800;">
                    Adicione pelo menos 1 mídia para o Carousel
                  </p>
                  </div>
                </div>
              </v-col>
      
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="d-sm-flex justify-center position-relative"
          >
            <div class="phone">
              <div class="speaker"></div>
              <div style="width: 425px; height: 771px">
                <div class="center">
                  <div class="chat">
                    <div
                      id="chat"
                      class="messages"
                    >
                      <div
                        v-if="formRcsChat"
                        class="message parker"
                      >
                        <!-- Preview para CAROUSEL -->
                        <div v-if="formRcs.typeRcs === 'CAROUSEL' && formRcs.carouselItems.length > 0" class="rcs-carousel-preview">
                          <div class="rcs-carousel-container">
                            <!-- Botão Anterior -->
                            <v-btn
                              v-if="formRcs.carouselItems.length > 1"
                              icon
                              small
                              class="carousel-nav-btn carousel-prev"
                              @click="previousCarouselImage"
                            >
                              <v-icon small>{{ icons.mdiChevronLeft }}</v-icon>
                            </v-btn>
                            
                            <!-- Item do Carousel -->
                            <div class="rcs-carousel-item">
                              <video
                                v-if="isVideoFile(formRcs.carouselItems[carouselIndex].file)"
                                :src="getCarouselImageUrl(carouselIndex)"
                                class="banner-image"
                                :style="getCarouselImageStyle(carouselIndex)"
                                controls
                              />
                              <img
                                v-else
                                :src="getCarouselImageUrl(carouselIndex)"
                                alt="RCS Carousel"
                                class="banner-image"
                                :style="getCarouselImageStyle(carouselIndex)"
                              />
                              <div class="rcs-content">
                                <h4 class="mb-1">{{ getCarouselTitle(carouselIndex) || formRcs.name }}</h4>
                                <p class="mb-2">{{ getCarouselMessage(carouselIndex) }}</p>
                                <v-btn
                                  v-if="getCarouselActionUrl(carouselIndex)"
                                  color="primary"
                                  small
                                  outlined
                                >
                                  {{ getCarouselButtonTitle(carouselIndex) || 'Ver mais' }}
                                </v-btn>
                              </div>
                            </div>
                            
                            <!-- Botão Próximo -->
                            <v-btn
                              v-if="formRcs.carouselItems.length > 1"
                              icon
                              small
                              class="carousel-nav-btn carousel-next"
                              @click="nextCarouselImage"
                            >
                              <v-icon small>{{ icons.mdiChevronRight }}</v-icon>
                            </v-btn>
                          </div>
                          
                          <!-- Indicadores (dots) -->
                          <div v-if="formRcs.carouselItems.length > 1" class="carousel-indicators">
                            <span
                              v-for="(item, index) in formRcs.carouselItems"
                              :key="index"
                              class="carousel-dot"
                              :class="{ active: index === carouselIndex }"
                              @click="carouselIndex = index"
                            />
                          </div>
                        </div>
                        <!-- Preview para SIMPLE_TEXT -->
                        <template v-else-if="formRcs.typeRcs === 'SIMPLE_TEXT'">
                          <div class="rcs-content simple-text-content">
                            <h4 v-if="formRcs.title" class="mb-1">{{ formRcs.title }}</h4>
                            <p class="mb-2">{{ formRcs.description }}</p>
                            <v-btn
                              v-if="formRcs.actionUrl"
                              color="primary"
                              small
                              outlined
                            >
                              {{ formRcs.buttonTitle || 'Ver mais' }}
                            </v-btn>
                          </div>
                        </template>
                        <!-- Preview para RICHCARD -->
                        <template v-else>
                          <div v-if="formRcs.imageUrl || formRcs.imageFiles.length > 0" class="rcs-banner">
                            <video
                              v-if="isVideoFile(formRcs.imageFiles[0])"
                              :src="getImageUrl(formRcs.imageFiles[0])"
                              class="banner-image"
                              :style="getRichCardImageStyle()"
                              controls
                            />
                            <img
                              v-else
                              :src="getImageUrl(formRcs.imageFiles[0])"
                              alt="RCS Banner"
                              class="banner-image"
                              :style="getRichCardImageStyle()"
                            />
                          </div>
                          <div class="rcs-content">
                            <h4 class="mb-1">{{ formRcs.title || formRcs.name }}</h4>
                            <p class="mb-2">{{ formRcs.description }}</p>
                            <v-btn
                              v-if="formRcs.actionUrl"
                              color="primary"
                              small
                              outlined
                            >
                              {{ formRcs.buttonTitle || 'Ver mais' }}
                            </v-btn>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="input">
                      <input
                        placeholder="Enviar mensagem..."
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </dialog-form>
    </validation-observer>

    <dialog-remove
      :status="removeDialogStatus"
      :text-to-confirm="form.name"
      @action="fetchActionRemove"
      @close="removeDialogStatus = !removeDialogStatus"
    >
    </dialog-remove>

    <tutorial tutorial-key="TSP1" />
  </div>
</template>

<style scoped>
.upload-area-wrapper {
  position: relative;
}

.upload-help-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  background-color: transparent !important;
}

.upload-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: transparent;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.upload-area:hover {
  border-color: #e2e1e1;
  background-color: transparent;
}

.upload-area.dragover {
  border-color: #e2e1e1;
  background-color: transparent;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.upload-text {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
}

.upload-subtext {
  font-size: 14px;
  color: #fff;
  margin: 0;
}

.upload-info {
  font-size: 12px;
  color: #ffffff;
  margin: 0;
}

.selected-file {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.file-name {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
  word-break: break-word;
  max-width: 200px;
  text-align: center;
}

.rcs-banner {
  width: 100%;
  margin-bottom: 12px;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  object-fit: cover;
  display: block;
}

.rcs-content {
  padding: 16px;
  border-radius: 0 0 8px 8px;
}

.files-selected {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.file-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.file-item .file-name {
  flex: 1;
  margin: 0;
  text-align: left;
  font-size: 14px;
}

.file-item .v-btn {
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.file-item .v-btn:hover {
  opacity: 1;
  transform: scale(1.1);
}

.rcs-carousel-preview {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
}

.rcs-carousel-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rcs-carousel-item {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  flex: 1;
}

.carousel-nav-btn {
  position: absolute;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5) !important;
  color: white !important;
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  border-radius: 50%;
}

.carousel-nav-btn:hover {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

.carousel-prev {
  left: 8px;
}

.carousel-next {
  right: 8px;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px;
}

.carousel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-dot:hover {
  background-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.2);
}

.carousel-dot.active {
  background-color: rgba(255, 255, 255, 0.9);
  width: 24px;
  border-radius: 4px;
}

.upload-area-small {
  padding: 20px 15px;
  min-height: 60px;
}

.upload-area-small .upload-content {
  gap: 4px;
}

.upload-area-small .upload-text {
  font-size: 14px;
}

.upload-area-small .upload-subtext {
  font-size: 12px;
}

.carousel-items-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.carousel-item-card {
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 12px;
  background-color: rgba(255, 255, 255, 0.03);
}

.carousel-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.carousel-item-number {
  font-weight: 600;
  font-size: 14px;
  color: #c9c9c9;
}

.carousel-item-content {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.carousel-item-image {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.carousel-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-item-form {
  flex: 1;
  min-width: 0;
}

.file-name-small {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.simple-text-content {
  background-color: #006064;
  border-radius: 8px;
  padding: 16px;
}
</style>

<script>
import { mapActions, mapState } from 'vuex'
import { mdiFileEdit, mdiMagnify, mdiTablePlus, mdiChevronLeft, mdiChevronRight, mdiClose, mdiHelpCircle } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { smsTemplateType, smsTypes } from '@/utils/enum'
import { ROLE_TYPE } from '@/store/auth/mutations'
import Tutorial from '@/components/tutorial/index.vue'

export default {
  components: {
    Tutorial,
  },
  setup() {
    const filterName = ref(null)
    const filterType = ref(null)
    const formDialogStatus = ref(false)
    const removeDialogStatus = ref(false)
    const formIsUpdate = ref(false)
    const total = ref(null)
    const messageChat = ref('')
    const userId = Number(localStorage.getItem('id'))
    const form = ref({
      id: ref(null),
      name: ref(''),
      message: ref(''),
      observation: ref(''),
      status: ref(null),
      type: ref(null),
      variables: ref([]),
      useVoiceOtp: ref(false),
    })

    // Formulário RCS
    const formRcs = ref({
      id: ref(null),
      name: ref(''),
      type: ref('RICHCARD'),
      typeRcs: ref('RICHCARD'),
      description: ref(''),
      title: ref(''), // Título para RICHCARD
      imageSize: ref('MEDIUM'), // Tamanho da imagem para RICHCARD
      actionUrl: ref(''),
      buttonTitle: ref(''), // Título do botão para RICHCARD e SIMPLE_TEXT
      imageFiles: ref([]),
      carouselItems: ref([]), // Array de { file, message, title, imageSize, actionUrl, buttonTitle } para CAROUSEL
      imageUrl: ref(''),
      variables: ref([]),
      supplier: ref(null), // Fornecedor selecionado
      fallbackTitle: ref(''), // Título do Fallback
      fallbackMessage: ref(''), // Mensagem do Fallback
    })

    // Fornecedores RCS
    let suppliers = []
    if (process.env.VUE_APP_EMPRESA_ID == 1 || process.env.VUE_APP_EMPRESA_ID == 8) {
      suppliers = [
        { text: 'RCS Ligdata Basic', value: { broker_code: 'rcs_ligdata_basic', customer_code: 'rcs_ligdata', type: 'basic' }, type: 'basic' },
        { text: 'RCS Ligdata Single', value: { broker_code: 'rcs_ligdata_single', customer_code: 'rcs_ligdata', type: 'single' }, type: 'single' },
        { text: 'RCS Ligdata Conversational', value: { broker_code: 'rcs_ligdata_conversational', customer_code: 'rcs_ligdata', type: 'conversational' }, type: 'conversational' },
        { text: 'RCS PIXBET Single', value: { broker_code: 'rcs_pixbet_single', customer_code: 'PIXBET', type: 'single' }, type: 'single' },
        { text: 'RCS Hands Digital Basic', value: { broker_code: 'HANDS DIGITAL', customer_code: 'PIXBET', type: 'basic' }, type: 'basic' },
        { text: 'RCS Hands Digital Single', value: { broker_code: 'HANDS DIGITAL', customer_code: 'PIXBET', type: 'single' }, type: 'single' },
      ]
    }
    if (process.env.VUE_APP_EMPRESA_ID == 2 || process.env.VUE_APP_EMPRESA_ID == 3 || process.env.VUE_APP_EMPRESA_ID == 4) {
      suppliers = [
        { text: 'RCS PIXBET Single', value: { broker_code: 'rcs_pixbet_single', customer_code: 'PIXBET', type: 'single' }, type: 'single' },
      ]
    }

    if (process.env.VUE_APP_EMPRESA_ID == 9) {
      suppliers = [
        { text: 'KING PANDA', value: { broker_code: 'KING PANDA', customer_code: 'rcs_ligdata', type: 'single' }, type: 'single' },
      ]
    }
    // Opções de tamanho de imagem
    const imageSizeOptions = [
      { text: 'Pequeno', value: 'SHORT' },
      { text: 'Médio', value: 'MEDIUM' },
      { text: 'Grande', value: 'TALL' },
    ]

    const formRcsDialogStatus = ref(false)
    const formRcsIsUpdate = ref(false)
    const formRcsChat = ref('')
    const isDragging = ref(false)
    const carouselIndex = ref(0)

    // Tipos de template RCS
    const rcsTemplateTypes = [
      { text: 'Texto Simples', value: 'SIMPLE_TEXT' },
      { text: 'Rich Card', value: 'RICHCARD' },
      //{ text: 'Arquivo', value: 'FILE' },
      //{ text: 'Texto', value: 'TEXT' },
      { text: 'Carrossel', value: 'CAROUSEL' }
    ]

    const resolveStatus = status => {


      if (status === 1) return { color: 'info', value: 'Aguardando Análise' }
      if (status === 2) return { color: 'success', value: 'Aprovado' }

      return { color: 'error', value: 'Recusado' }
    }

    const resolveServiceName = serviceId => {
      // Se o usuário for 941, mostrar apenas os serviços com serviceId 6 (Lig Massiva) e 7 (Lig Flash)
      if (process.env.VUE_APP_EMPRESA_ID == 1 && userId === 941 && serviceId !== 6 && serviceId !== 7 && serviceId !== 30) {
        return null
      }

      const service = smsTypes.find(smsType => smsType.serviceId === serviceId)

      if (service) {
        return service.text
      }

      return null
    }

    return {
      total,
      filterName,
      filterType,
      form,
      formDialogStatus,
      removeDialogStatus,
      formIsUpdate,
      messageChat,
      resolveStatus,
      resolveServiceName,
      
      // RCS
      formRcs,
      formRcsDialogStatus,
      formRcsIsUpdate,
      formRcsChat,
      rcsTemplateTypes,
      imageSizeOptions,
      isDragging,
      carouselIndex,
      suppliers,
      
      icons: {
        mdiFileEdit,
        mdiMagnify,
        mdiTablePlus,
        mdiChevronLeft,
        mdiChevronRight,
        mdiClose,
        mdiHelpCircle,
      },
      headers: [
        { text: 'Ações', value: 'action', align: 'center' },
        { text: 'ID', value: 'id' },
        { text: 'Nome', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'Variáveis', value: 'variables' },
        { text: 'Serviços Associados', value: 'serviceIds' },
      ],
    }
  },

  computed: {
    ...mapState('smsTemplates', [
      'rows',
    ]),
    isAdmin() {
      const role = Number(Buffer.from(localStorage.getItem('role'), 'base64'))

      return role === ROLE_TYPE.admin
    },
    // Filtra os tipos de template RCS baseado no fornecedor selecionado
    availableRcsTypes() {
      // Encontrar o fornecedor selecionado para obter o type
      const selectedSupplier = this.suppliers.find(s =>
        s.value && this.formRcs.supplier &&
        s.value.broker_code === this.formRcs.supplier.broker_code &&
        s.value.customer_code === this.formRcs.supplier.customer_code &&
        s.value.type === this.formRcs.supplier.type
      )
      
      // Se for basic, apenas SIMPLE_TEXT
      if (selectedSupplier && selectedSupplier.type === 'basic') {
        return this.rcsTemplateTypes.filter(t => t.value === 'SIMPLE_TEXT')
      }
      
      // Para outros tipos (single, conversational), todas as opções
      return this.rcsTemplateTypes
    },
    // Retorna o texto completo do tooltip com todas as medidas
    imageDimensionsTooltip() {
      const type = this.formRcs.typeRcs
      
      if (type === 'RICHCARD') {
        return 'Rich Card:\nPequena: 1550x440px\nMédia: 1550x660px\nGrande: 1550x1036px \nTamanho Maximo Imagem (ate 2MB) \n Tamanho Maximo para Video (ate 20MB)'
      } else if (type === 'CAROUSEL') {
        return 'Carrossel:\nPequena: 1340x640px\nMédia: 1340x980px\nGrande: 1340x1530px \nTamanho Maximo Imagem (ate 2MB) \n Tamanho Maximo para Video (ate 20MB)'
      }
      return ''
    },
  },

  watch: {
    // eslint-disable-next-line func-names
    'form.message': function (value) {
      const text = value.replace(/(?:\r\n|\r|\n)/g, '<br>')

      this.messageChat = this.$utils.replaceSpecialCharacters(text)
      this.form.variables = this.getVariables(value)
      this.form.message = this.fixTemplateContent(value)
    },

    // Watch para RCS
    'formRcs.name': function (value) {
      this.updateRcsChat();
    },

    // Watch para quando mudar o fornecedor
    'formRcs.supplier': function (newSupplier, oldSupplier) {
      // Verificar se realmente mudou de fornecedor
      if (!newSupplier || (oldSupplier && oldSupplier.broker_code === newSupplier.broker_code &&
          oldSupplier.customer_code === newSupplier.customer_code &&
          oldSupplier.type === newSupplier.type)) {
        return;
      }

      // Resetar campos dependentes do fornecedor
      this.formRcs.typeRcs = 'RICHCARD'; // Resetar para padrão
      this.formRcs.imageSize = 'TALL';

      // Encontrar o fornecedor selecionado para obter o type
      const selectedSupplier = this.suppliers.find(s =>
        s.value && s.value.broker_code === newSupplier.broker_code &&
        s.value.customer_code === newSupplier.customer_code &&
        s.value.type === newSupplier.type
      );

      if (selectedSupplier && selectedSupplier.type === 'basic') {
        // Se for basic, forçar SIMPLE_TEXT
        this.formRcs.typeRcs = 'SIMPLE_TEXT';
        // Resetar campos que não existem no SIMPLE_TEXT
        this.formRcs.imageSize = null;
        this.formRcs.actionUrl = '';
        this.formRcs.buttonTitle = '';
        this.formRcs.imageFiles = [];
        this.formRcs.carouselItems = [];
      }

      // Forçar atualização do computed para refiltrar os tipos disponíveis
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    'formRcs.description': function (value) {
      this.formRcs.variables = this.getVariables(value);
      this.formRcs.description = this.fixTemplateContent(value);
      this.updateRcsChat();
    },

    'formRcs.typeRcs': function (value, oldValue) {
      // Resetar o input de arquivo quando mudar o tipo
      this.$nextTick(() => {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = '';
        }
      });

      // Resetar índice do carousel
      this.carouselIndex = 0;

      // Quando mudar para SIMPLE_TEXT, limpar campos de botão
      if (value === 'SIMPLE_TEXT') {
        this.formRcs.actionUrl = '';
        this.formRcs.buttonTitle = '';
      }

      // Quando mudar de CAROUSEL para RICHCARD
      if (value === 'RICHCARD' && oldValue === 'CAROUSEL') {
        // Limpar URLs temporárias dos carouselItems
        this.formRcs.carouselItems.forEach(item => {
          if (item.file && item.file._tempUrl) {
            try {
              window.URL.revokeObjectURL(item.file._tempUrl);
            } catch (error) {
              console.error('Erro ao limpar URL temporária:', error);
            }
          }
        });
        // Converter primeiro item do carousel para imageFiles (se existir)
        if (this.formRcs.carouselItems.length > 0) {
          this.formRcs.imageFiles = [this.formRcs.carouselItems[0].file];
          this.formRcs.description = this.formRcs.carouselItems[0].message || '';
          this.formRcs.actionUrl = this.formRcs.carouselItems[0].actionUrl || '';
          this.formRcs.buttonTitle = this.formRcs.carouselItems[0].buttonTitle || '';
        }
        this.formRcs.carouselItems = [];
        if (this.formRcs.imageFiles.length > 0) {
          this.$notify('Convertido para Rich Card. Apenas a primeira imagem foi mantida.', 'info');
        }
      }
      
      // Quando mudar de RICHCARD para CAROUSEL
      if (value === 'CAROUSEL' && oldValue === 'RICHCARD') {
        // Converter imageFiles para carouselItems
        if (this.formRcs.imageFiles.length > 0) {
          this.formRcs.carouselItems = this.formRcs.imageFiles.map(file => ({
            file,
            message: this.formRcs.description || '',
            title: this.formRcs.title || '',
            imageSize: this.formRcs.imageSize || 'MEDIUM',
            actionUrl: this.formRcs.actionUrl || '',
            buttonTitle: this.formRcs.buttonTitle || ''
          }));
        }
        this.formRcs.imageFiles = [];
        this.formRcs.description = '';
      }
      
      this.updateRcsChat();
    },

    'formRcs.imageFiles': function (newFiles, oldFiles) {
      // Resetar índice do carousel se as imagens mudarem (apenas para RICHCARD)
      if (this.formRcs.typeRcs === 'RICHCARD') {
        if (newFiles.length === 0 || (oldFiles && newFiles.length !== oldFiles.length)) {
          this.carouselIndex = 0;
        }
        if (this.carouselIndex >= newFiles.length && newFiles.length > 0) {
          this.carouselIndex = newFiles.length - 1;
        }
      }
    },

    'formRcs.carouselItems': {
      handler(newItems, oldItems) {
        // Resetar índice do carousel se os itens mudarem
        if (newItems.length === 0 || (oldItems && newItems.length !== oldItems.length)) {
          if (this.carouselIndex >= newItems.length && newItems.length > 0) {
            this.carouselIndex = newItems.length - 1;
          } else if (newItems.length === 0) {
            this.carouselIndex = 0;
          }
        }
        this.updateRcsChat();
      },
      deep: true
    },
  },

  async created() {
    await this.fechSmsTemplates()
  },

  methods: {
    ...mapActions('smsTemplates', [
      'find',
      'findById',
      'create',
      'update',
      'remove',
      'createTemplateRCS',
      'updateTemplateRCS',
    ]),
    ...mapActions('controlFile', {
      getFileById: 'findById',
    }),

    getMessageLenth(value) {
      return String(value.replace(/(?:\r\n|\r|\n)/g, '\n\n')).length
    },

    getVariables(text) {
      const regex = /\{([^}]+)\}/g

      return String(text).match(regex)?.map(v => v.slice(1, -1).toUpperCase()) || []
    },

    fixTemplateContent(text) {
      const regex = /\{([^}]+)\}/g

      return String(text).replace(regex, (_, p1) => `{${p1.toUpperCase()}}`)
    },

    async openFormToCreate() {
      this.formDialogStatus = true
      this.formIsUpdate = false
      this.messageChat = ''
      this.form = {
        id: null,
        name: null,
        observation: '',
        message: '',
        status: null,
        type: smsTemplateType.Default,
        variables: [],
        useVoiceOtp: false,
      }
    },

    async openFormToCreateRcs() {
      this.formRcsDialogStatus = true
      this.formRcsIsUpdate = false
      this.formRcsChat = false 
      this.isDragging = false
      this.carouselIndex = 0
      this.formRcs = {
        id: null,
        name: '',
        type: 1,
        typeRcs: 'RICHCARD',
        description: '',
        title: '',
        imageSize: 'TALL',
        actionUrl: '',
        buttonTitle: '',
        imageFiles: [],
        carouselItems: [], // Array de { file, message, title, imageSize, actionUrl, buttonTitle }
        imageUrl: '',
        variables: [],
        useVoiceOtp: false,
        supplier: null,
        fallbackTitle: '',
        fallbackMessage: '',
      }
      this.updateRcsChat();
    },

    onFileDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const files = this.validateMediaFiles(Array.from(event.dataTransfer.files));
      
      if (files.length === 0) {
        this.isDragging = false;
        return;
      }

      if (this.formRcs.typeRcs === 'RICHCARD') {
        // Apenas 1 mídia para RICHCARD - substituir a anterior se existir
        if (files.length > 1) {
          this.$notify('Rich Card permite apenas 1 mídia. Apenas a primeira será selecionada.', 'warning');
        }
        // Limpar URL temporária da mídia anterior se existir
        if (this.formRcs.imageFiles.length > 0 && this.formRcs.imageFiles[0]._tempUrl) {
          try {
            window.URL.revokeObjectURL(this.formRcs.imageFiles[0]._tempUrl);
          } catch (error) {
            console.error('Erro ao limpar URL temporária:', error);
          }
        }
        this.formRcs.imageFiles = [files[0]];
      } else {
        // Múltiplas mídias para CAROUSEL - adicionar ao carouselItems com campos vazios
        const newItems = files.map(file => ({ 
          file, 
          message: '', 
          title: '', 
          imageSize: 'MEDIUM', 
          actionUrl: '',
          buttonTitle: ''
        }));
        this.formRcs.carouselItems = [...this.formRcs.carouselItems, ...newItems];
      }
      
      this.updateRcsChat();
      this.isDragging = false;
    },

    onDragEnter() {
      this.isDragging = true;
    },

    onDragLeave() {
      this.isDragging = false;
    },

    onFileSelect(event) {
      const files = this.validateMediaFiles(Array.from(event.target.files));
      
      if (files.length === 0) {
        event.target.value = '';
        return;
      }

      if (this.formRcs.typeRcs === 'RICHCARD') {
        // Apenas 1 mídia para RICHCARD - substituir a anterior se existir
        if (files.length > 1) {
          this.$notify('Rich Card permite apenas 1 mídia. Apenas a primeira será selecionada.', 'warning');
        }
        // Limpar URL temporária da mídia anterior se existir
        if (this.formRcs.imageFiles.length > 0 && this.formRcs.imageFiles[0]._tempUrl) {
          try {
            window.URL.revokeObjectURL(this.formRcs.imageFiles[0]._tempUrl);
          } catch (error) {
            console.error('Erro ao limpar URL temporária:', error);
          }
        }
        this.formRcs.imageFiles = [files[0]];
      } else {
        // Múltiplas mídias para CAROUSEL - adicionar ao carouselItems com campos vazios
        const newItems = files.map(file => ({ 
          file, 
          message: '', 
          title: '', 
          imageSize: 'MEDIUM', 
          actionUrl: '',
          buttonTitle: ''
        }));
        this.formRcs.carouselItems = [...this.formRcs.carouselItems, ...newItems];
      }
      
      this.updateRcsChat();
      // Limpar o input para permitir selecionar o mesmo arquivo novamente
      event.target.value = '';
    },

    validateMediaFiles(files) {
      const invalidFile = files.find(file =>
        !file.type.startsWith('image/') && !file.type.startsWith('video/')
      );

      if (invalidFile) {
        this.$notify('Selecione apenas arquivos de imagem ou vídeo.', 'error');
        return [];
      }

      const oversizedFile = files.find(file => {
        const maxSize = file.type.startsWith('video/')
          ? 20 * 1024 * 1024
          : 2 * 1024 * 1024;

        return file.size > maxSize;
      });

      if (oversizedFile) {
        const maxSizeLabel = oversizedFile.type.startsWith('video/') ? '20 MB' : '2 MB';
        this.$notify(`O arquivo "${oversizedFile.name}" excede o limite de ${maxSizeLabel}.`, 'error');
        return [];
      }

      return files;
    },

    isVideoFile(file) {
      return Boolean(file && file.type && file.type.startsWith('video/'));
    },

    openFileSelector() {
      this.$refs.fileInput.click();
    },

    removeImage(index) {
      if (index !== undefined && this.formRcs.imageFiles[index]) {
        // Limpar URL temporária se existir
        const file = this.formRcs.imageFiles[index];
        if (file._tempUrl) {
          try {
            window.URL.revokeObjectURL(file._tempUrl);
          } catch (error) {
            console.error('Erro ao limpar URL temporária:', error);
          }
        }
        
        // Ajustar índice do carousel se necessário
        if (this.formRcs.typeRcs === 'CAROUSEL') {
          const totalImages = this.formRcs.imageFiles.length;
          // Se está removendo a imagem atual ou uma imagem após a atual
          if (index <= this.carouselIndex) {
            // Se não é a última imagem, manter o índice (que agora apontará para a próxima)
            // Se é a última imagem, voltar para a anterior
            if (this.carouselIndex >= totalImages - 1 && totalImages > 1) {
              this.carouselIndex = totalImages - 2;
            } else if (this.carouselIndex > 0) {
              this.carouselIndex = this.carouselIndex - 1;
            } else {
              this.carouselIndex = 0;
            }
          }
        }
        
        this.formRcs.imageFiles.splice(index, 1);
        
        // Se não sobrou nenhuma imagem, resetar o índice
        if (this.formRcs.imageFiles.length === 0) {
          this.carouselIndex = 0;
        }
      } else {
        // Remover todas as imagens
        this.formRcs.imageFiles.forEach(file => {
          if (file._tempUrl) {
            try {
              window.URL.revokeObjectURL(file._tempUrl);
            } catch (error) {
              console.error('Erro ao limpar URL temporária:', error);
            }
          }
        });
        this.formRcs.imageFiles = [];
        this.carouselIndex = 0;
      }
      this.updateRcsChat();
      // Resetar o input de arquivo
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },

    updateRcsChat() {
      const hasCarouselItems = this.formRcs.carouselItems && this.formRcs.carouselItems.length > 0;
      this.formRcsChat = this.formRcs.name || this.formRcs.description || this.formRcs.imageFiles.length > 0 || this.formRcs.imageUrl || hasCarouselItems ? true : false;
    },

    removeCarouselItem(index) {
      if (index !== undefined && this.formRcs.carouselItems[index]) {
        // Limpar URL temporária se existir
        const item = this.formRcs.carouselItems[index];
        if (item.file && item.file._tempUrl) {
          try {
            window.URL.revokeObjectURL(item.file._tempUrl);
          } catch (error) {
            console.error('Erro ao limpar URL temporária:', error);
          }
        }
        
        // Ajustar índice do carousel se necessário
        const totalItems = this.formRcs.carouselItems.length;
        if (index <= this.carouselIndex) {
          if (this.carouselIndex >= totalItems - 1 && totalItems > 1) {
            this.carouselIndex = totalItems - 2;
          } else if (this.carouselIndex > 0) {
            this.carouselIndex = this.carouselIndex - 1;
          } else {
            this.carouselIndex = 0;
          }
        }
        
        this.formRcs.carouselItems.splice(index, 1);
        
        // Se não sobrou nenhum item, resetar o índice
        if (this.formRcs.carouselItems.length === 0) {
          this.carouselIndex = 0;
        }
      }
      this.updateRcsChat();
    },

    updateCarouselMessage(index, message) {
      if (this.formRcs.carouselItems[index]) {
        this.formRcs.carouselItems[index].message = message;
      }
    },

    getImageUrl(file) {
      if (this.formRcs.imageUrl && !file) {
        return this.formRcs.imageUrl;
      }
      if (file) {
        try {
          // Criar URL temporária se não existir
          if (!file._tempUrl) {
            file._tempUrl = window.URL.createObjectURL(file);
          }
          return file._tempUrl;
        } catch (error) {
          console.error('Erro ao criar URL da imagem:', error);
          return '';
        }
      }
      return '';
    },

    nextCarouselImage() {
      const items = this.formRcs.typeRcs === 'CAROUSEL' ? this.formRcs.carouselItems : this.formRcs.imageFiles;
      if (items.length > 0) {
        this.carouselIndex = (this.carouselIndex + 1) % items.length;
      }
    },

    previousCarouselImage() {
      const items = this.formRcs.typeRcs === 'CAROUSEL' ? this.formRcs.carouselItems : this.formRcs.imageFiles;
      if (items.length > 0) {
        this.carouselIndex = this.carouselIndex === 0 
          ? items.length - 1 
          : this.carouselIndex - 1;
      }
    },

    getCarouselImageUrl(index) {
      const item = this.formRcs.carouselItems[index];
      if (item && item.file) {
        return this.getImageUrl(item.file);
      }
      return '';
    },

    getCarouselMessage(index) {
      const item = this.formRcs.carouselItems[index];
      if (item && item.message) {
        return item.message;
      }
      return 'Adicione uma mensagem para este slide';
    },

    getCarouselTitle(index) {
      const item = this.formRcs.carouselItems[index];
      if (item && item.title) {
        return item.title;
      }
      return '';
    },

    getCarouselActionUrl(index) {
      const item = this.formRcs.carouselItems[index];
      if (item && item.actionUrl) {
        return item.actionUrl;
      }
      return '';
    },

    getCarouselButtonTitle(index) {
      const item = this.formRcs.carouselItems[index];
      if (item && item.buttonTitle) {
        return item.buttonTitle;
      }
      return '';
    },

    // Calcula o estilo da imagem RICHCARD baseado no tamanho
    getRichCardImageStyle() {
      const size = this.formRcs.imageSize || 'TALL';
      const dimensions = this.getImageDimensions('RICHCARD', size);
      
      return {
        width: '100%',
        height: dimensions.height,
        objectFit: 'cover',
        display: 'block',
      }
    },

    // Calcula o estilo da imagem do carousel baseado no tamanho
    getCarouselImageStyle(index) {
      const item = this.formRcs.carouselItems[index];
      const size = item && item.imageSize ? item.imageSize : 'MEDIUM';
      const dimensions = this.getImageDimensions('CAROUSEL', size);
      
      return {
        width: '100%',
        height: dimensions.height,
        objectFit: 'cover',
        display: 'block',
      }
    },

    // Retorna as dimensões corretas baseado no tipo e tamanho
    getImageDimensions(type, size) {
      // RICHCARD: SHORT=1550x440px, MEDIUM=1550x660px, TALL=1550x1036px
      // CAROUSEL: SHORT=1340x640px, MEDIUM=1340x980px, TALL=1340x1530px
      
      // Proporções para o preview (largura fixa de ~300px no preview)
      const previewWidth = 300
      
      if (type === 'RICHCARD') {
        const aspectRatios = {
          SHORT: 440 / 1550,   // altura/largura
          MEDIUM: 660 / 1550,
          TALL: 1036 / 1550,
        }
        const aspectRatio = aspectRatios[size] || aspectRatios.MEDIUM
        return {
          width: `${previewWidth}px`,
          height: `${previewWidth * aspectRatio}px`,
        }
      } else if (type === 'CAROUSEL') {
        const aspectRatios = {
          SHORT: 640 / 1340,
          MEDIUM: 980 / 1340,
          TALL: 1530 / 1340,
        }
        const aspectRatio = aspectRatios[size] || aspectRatios.MEDIUM
        return {
          width: `${previewWidth}px`,
          height: `${previewWidth * aspectRatio}px`,
        }
      }
      
      // Fallback
      return {
        width: `${previewWidth}px`,
        height: `${previewWidth * 0.6}px`,
      }
    },
    
    // Método para obter URL pública da imagem salva
    getPublicImageUrl(imageFileId) {
      if (!imageFileId) return '';
      return `${this.$axios.defaults.baseURL}/public/files/${imageFileId}`;
    },

    async fetchActionRcs() {
        if (await this.$refs.formRcsTemplate.validate()) {
          // Validação: RICHCARD deve ter no máximo 1 imagem
          if (this.formRcs.typeRcs === 'RICHCARD' && this.formRcs.imageFiles.length > 1) {
            this.$notify(
              'Rich Card permite apenas 1 mídia. Remova os arquivos extras.',
              'error',
            )
            return
          }

          // Validação: CAROUSEL deve ter pelo menos 1 imagem
          if (this.formRcs.typeRcs === 'CAROUSEL' && this.formRcs.carouselItems.length === 0 && !this.formRcs.imageUrl) {
            this.$notify(
              'Carousel requer pelo menos 1 mídia.',
              'error',
            )
            return
          }

          // Validação: CAROUSEL deve ter mensagem em todos os slides
          if (this.formRcs.typeRcs === 'CAROUSEL') {
            const emptyMessages = this.formRcs.carouselItems.filter(item => !item.message || item.message.trim() === '');
            if (emptyMessages.length > 0) {
              this.$notify(
                `Preencha a mensagem de todos os slides do Carousel. ${emptyMessages.length} slide(s) sem mensagem.`,
                'error',
              )
              return
            }
          }

          console.log('Template RCS:', this.formRcs)

        let body;
        
        // Obter dados do fornecedor selecionado
        const supplierData = this.formRcs.supplier || {}
        const selectedSupplier = this.suppliers.find(s =>
          s.value &&
          s.value.broker_code === supplierData.broker_code &&
          s.value.customer_code === supplierData.customer_code &&
          s.value.type === supplierData.type
        )
        const supplierType = selectedSupplier ? selectedSupplier.type : null

        const isUpdate = !!this.formRcs.id

        if (this.formRcs.typeRcs === 'CAROUSEL') {
          // Para CAROUSEL: enviar carouselItems com arquivos e dados
          body = {
            name: this.formRcs.name,
            message: '', // Não usa mensagem principal no CAROUSEL
            type: Number(this.formRcs.type),
            typeRcs: this.formRcs.typeRcs,
            actionUrl: this.formRcs.actionUrl,
            variables: [],
            // Enviar arquivos do carousel
            imageFile: this.formRcs.carouselItems.map(item => item.file),
            // Enviar dados do carousel como JSON
            carouselMessages: this.formRcs.carouselItems.map(item =>
              this.$utils.replaceSpecialCharacters(item.message)
            ),
            carouselTitles: this.formRcs.carouselItems.map(item => item.title || ''),
            carouselSizes: this.formRcs.carouselItems.map(item => item.imageSize || 'MEDIUM'),
            carouselActionUrls: this.formRcs.carouselItems.map(item => item.actionUrl || ''),
            carouselButtonTitles: this.formRcs.carouselItems.map(item => item.buttonTitle || ''),
            imageUrl: this.formRcs.imageUrl,
            useVoiceOtp: this.formRcs.useVoiceOtp,
            // Dados do fornecedor
            brokerCode: supplierData.broker_code,
            customerCode: supplierData.customer_code,
            supplierType: supplierType,
            // Campos de fallback
            fallbackTitle: this.formRcs.fallbackTitle,
            fallbackMessage: this.formRcs.fallbackMessage,
          }
        } else if (this.formRcs.typeRcs === 'SIMPLE_TEXT') {
          // Para SIMPLE_TEXT: apenas título e mensagem (sem imagem, sem botão)
          body = {
            name: this.formRcs.name,
            message: this.$utils.replaceSpecialCharacters(this.formRcs.description),
            title: this.formRcs.title || '',
            type: Number(this.formRcs.type),
            typeRcs: this.formRcs.typeRcs,
            variables: this.formRcs.variables,
            useVoiceOtp: this.formRcs.useVoiceOtp,
            // Dados do fornecedor
            brokerCode: supplierData.broker_code,
            customerCode: supplierData.customer_code,
            supplierType: supplierType,
            // Campos de fallback
            fallbackTitle: this.formRcs.fallbackTitle,
            fallbackMessage: this.formRcs.fallbackMessage,
          }
        } else {
          // Para RICHCARD: com imagem, tamanho e URL de ação
          body = {
            name: this.formRcs.name,
            message: this.$utils.replaceSpecialCharacters(this.formRcs.description),
            title: this.formRcs.title || '',
            imageSize: this.formRcs.imageSize || 'TALL',
            type: Number(this.formRcs.type),
            typeRcs: this.formRcs.typeRcs,
            actionUrl: this.formRcs.actionUrl,
            buttonTitle: this.formRcs.buttonTitle || '',
            variables: this.formRcs.variables,
            imageFile: this.formRcs.imageFiles.length > 0 ? this.formRcs.imageFiles[0] : null,
            imageUrl: this.formRcs.imageUrl,
            useVoiceOtp: this.formRcs.useVoiceOtp,
            // Dados do fornecedor
            brokerCode: supplierData.broker_code,
            customerCode: supplierData.customer_code,
            supplierType: supplierType,
            // Campos de fallback
            fallbackTitle: this.formRcs.fallbackTitle,
            fallbackMessage: this.formRcs.fallbackMessage,
          }

          if (this.getMessageLenth(body.message) > 999) {
            this.$notify(
              'O campo mensagem pode conter até 999 caracteres.',
              'error',
            )
            return
          }
        }

        // Adicionar ID se for update
        if (isUpdate) {
          body.id = this.formRcs.id
        }

        // Chamar create ou update baseado no ID
        if (isUpdate) {
          await this.updateTemplateRCS(body)
          this.$notify(
            'Template RCS atualizado com sucesso!',
            'success',
          )
        } else {
          await this.createTemplateRCS(body)
          this.$notify(
            'Template RCS criado com sucesso!',
            'success',
          )
        }

        this.fechSmsTemplates()
        this.formDialogStatus = false
        this.formRcsDialogStatus = false
      }
    },

    async openFormToEdit(rowId) {
      const smsTemplate = await this.findById(rowId)

      if (smsTemplate) {
        // Se for template RCS, abrir formulário RCS
        if (smsTemplate.isRcs === 1) {
          await this.openFormToEditRcs(smsTemplate)
          return
        }

        // Se não for RCS, abrir formulário normal
        await this.$refs.formSmsTemplate.reset()
        this.formDialogStatus = true
        this.formIsUpdate = true
        this.form = {
          id: smsTemplate.id,
          name: smsTemplate.name,
          message: smsTemplate.message,
          observation: '',
          status: smsTemplate.status,
          type: Number(smsTemplate.type),
          variables: smsTemplate.variables,
          useVoiceOtp: smsTemplate.useVoiceOtp,
        }
      }
    },

    async openFormToEditRcs(smsTemplate) {
      this.formRcsDialogStatus = true
      this.formRcsIsUpdate = true
      this.formRcsChat = false
      this.isDragging = false
      this.carouselIndex = 0
      
      // Buscar template completo se for CAROUSEL para pegar carouselItems
      let fullTemplate = smsTemplate
      if (smsTemplate.typeRcs === 'CAROUSEL') {
        const templateWithCarousel = await this.findById(smsTemplate.id)
        if (templateWithCarousel && templateWithCarousel.carouselItems) {
          fullTemplate = templateWithCarousel
        }
      }

      // Preencher dados básicos
      this.formRcs = {
        id: fullTemplate.id,
        name: fullTemplate.name || '',
        type: Number(fullTemplate.type) || 1,
        typeRcs: fullTemplate.typeRcs || 'RICHCARD',
        description: fullTemplate.message || '',
        title: fullTemplate.titulo || '',
        imageSize: fullTemplate.tamanho || 'MEDIUM',
        actionUrl: fullTemplate.urlAction || '',
        buttonTitle: fullTemplate.buttonTitle || '',
        imageFiles: [],
        carouselItems: [],
        imageUrl: '',
        variables: fullTemplate.variables || [],
        useVoiceOtp: fullTemplate.useVoiceOtp || false,
        supplier: null,
        fallbackTitle: fullTemplate.fallbackTitle || '',
        fallbackMessage: fullTemplate.fallbackMessage || '',
      }

      // Buscar fornecedor baseado no brokerCode, customerCode e supplierType
      if (fullTemplate.brokerCode && fullTemplate.customerCode && fullTemplate.supplierType) {
        const supplier = this.suppliers.find(s =>
          s.value &&
          s.value.broker_code === fullTemplate.brokerCode &&
          s.value.customer_code === fullTemplate.customerCode &&
          s.value.type === fullTemplate.supplierType
        )
        if (supplier) {
          this.formRcs.supplier = supplier.value
        }
      } else if (fullTemplate.brokerCode && fullTemplate.customerCode) {
        // Fallback para templates antigos sem supplierType
        const supplier = this.suppliers.find(s =>
          s.value &&
          s.value.broker_code === fullTemplate.brokerCode &&
          s.value.customer_code === fullTemplate.customerCode
        )
        if (supplier) {
          this.formRcs.supplier = supplier.value
        }
      }

      // Se for CAROUSEL, carregar carouselItems
      if (fullTemplate.typeRcs === 'CAROUSEL' && fullTemplate.carouselItems && fullTemplate.carouselItems.length > 0) {
        const carouselItems = fullTemplate.carouselItems.sort((a, b) => (a.itemOrder || 0) - (b.itemOrder || 0))
        
        // Carregar imagens e dados do carousel
        const items = []
        for (const item of carouselItems) {
          try {
            const file = await this.getFileById(item.fileId)
            if (file && file.data) {
              const blob = new Blob([new Uint8Array(file.data)], { type: file.contentType || 'image/png' })
              const fileObj = new File([blob], file.name || 'image.png', { type: file.contentType || 'image/png' })
              fileObj._tempUrl = URL.createObjectURL(blob)
              
              items.push({
                file: fileObj,
                message: item.message || '',
                title: item.titulo || '',
                imageSize: item.tamanho || 'MEDIUM',
                actionUrl: item.urlAction || '',
                buttonTitle: item.buttonTitle || '',
              })
            }
          } catch (error) {
            console.error(`Erro ao carregar imagem do carousel ${item.fileId}:`, error)
          }
        }
        this.formRcs.carouselItems = items
      } else if (fullTemplate.typeRcs === 'RICHCARD' && fullTemplate.imageFileId) {
        // Se for RICHCARD, carregar imagem
        try {
          let imageFileIds = []
          if (typeof fullTemplate.imageFileId === 'string') {
            try {
              imageFileIds = JSON.parse(fullTemplate.imageFileId)
            } catch {
              imageFileIds = [Number(fullTemplate.imageFileId)]
            }
          } else if (Array.isArray(fullTemplate.imageFileId)) {
            imageFileIds = fullTemplate.imageFileId
          } else {
            imageFileIds = [fullTemplate.imageFileId]
          }

          if (imageFileIds.length > 0) {
            const file = await this.getFileById(imageFileIds[0])
            if (file && file.data) {
              const blob = new Blob([new Uint8Array(file.data)], { type: file.contentType || 'image/png' })
              const fileObj = new File([blob], file.name || 'image.png', { type: file.contentType || 'image/png' })
              fileObj._tempUrl = URL.createObjectURL(blob)
              this.formRcs.imageFiles = [fileObj]
            }
          }
        } catch (error) {
          console.error('Erro ao carregar imagem do RICHCARD:', error)
        }
      }

      this.updateRcsChat()
    },

    async fechSmsTemplates() {
      await this.find({
        name: this.filterName,
        type: this.filterType,
      })
    },

    async fetchAction(isUpdate) {
      const body = {
        name: this.form.name,
        message: this.$utils.replaceSpecialCharacters(this.form.message),
        status: this.form.status,
        type: Number(this.form.type),
        variables: this.form.variables,
        useVoiceOtp: this.form.useVoiceOtp == 1 ? true : false,
      }

      if (this.getMessageLenth(body.message) > 160) {
        this.$notify(
          'O campo mensagem pode conter até 160 caracteres.',
          'error',
        )

        return
      }

      if (await this.$refs.formSmsTemplate.validate()) {
        if (isUpdate) await this.update(body)
        else await this.create(body)

        this.fechSmsTemplates()
        this.formDialogStatus = false
      }
    },

    async fetchActionRemove() {
      try {
        if (this.form.id) {
          await this.remove(this.form.id)
        }
      } finally {
        this.fechSmsTemplates()
        this.formDialogStatus = false
        this.removeDialogStatus = false
      }
    },
  },
}

</script>
